




































import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import SubjectForm1 from './subject-form-1.vue';
import SubjectForm2 from './subject-form-2.vue';
import SubjectForm3 from './subject-form-3.vue';
import SubjectForm4 from './subject-form-4.vue';
import SubjectForm5 from './subject-form-5.vue';
import SubjectForm6 from './subject-form-6.vue';
import SubjectServices, { SubjectDto, SubjectItemDto } from '@/services/subject';
import { Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { checkCode } from '@/libs/util';

@Component({
  components: { SubjectForm1, SubjectForm2, SubjectForm3, SubjectForm4, SubjectForm5, SubjectForm6 }
})
export default class SubjectForm extends mixins(BaseFormMixin) {
  breadList = [{ name: '创建主题表' }];
  subjectSrv = new SubjectServices();

  formData: SubjectDto = {};
  subFieldList: SubjectItemDto[] = [];
  oldFieldList: SubjectItemDto[] = [];
  subSyncDefs: any = {};
  id: any = 0;
  categoryId: any = 0;
  keepalive: boolean = true;

  initFormData() {
    this.subSyncDefs = {
      cronExpression: '0 0 2 * * ?',
      databaseConfig: {
        mappings: [],
        source: {
          databaseName: '', // 数据资源
          sourceId: 1,
          sourceName: '', // 数据源
          tableName: '' // 数据对象
        }
      },
      inputdataConfig: [],
      jobMode: 0,
      sqlqueryConfig: {
        limit: 10,
        pageNo: 1,
        pageSize: 10,
        source: {
          id: 1,
          name: ''
        },
        sqlquery: '',
        variables: []
      },
      jobConfig: {
        rate: 0,
        runDateFormat: '',
        runDateStr: ''
      },
      syncMode: 0
    };
    this.formData = {};
    this.subFieldList = [];
    this.current = 0;
  }

  created() {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.initFormData();
  }

  activated() {
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    this.id = this.$route.query.id;
    let path = this.$route.path;

    if (path == '/decision/subject/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;

      this.initFormData();

      let categories = await this.subjectSrv.getTree();
      let category = categories.filter((category: any) => category.id == this.categoryId)[0];
      this.breadList = [{ name: category.categoryName }, { name: '创建主题表' }];
    }
    if (path == '/decision/subject/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      let res = await this.subjectSrv.getInfo(this.id);
      this.spinning = false;
      if (!res) return false;
      this.formData = res.subDef;
      this.oldFieldList = JSON.parse(JSON.stringify(res.subFieldList));
      this.subFieldList = res.subFieldList;
      this.subSyncDefs = res.subSyncDefs;
      this.initEditData(res.subSyncDefs);
      this.current = 0;
      this.subSyncDefs.jobConfig = JSON.parse(this.subSyncDefs.jobConfig);
      this.breadList = [{ name: res.subDef.subCategoryName || '' }, { name: res.subDef.subName || '' }, { name: '编辑主题表' }];
    }
  }

  // 解析syncConfig数据
  initEditData(subSyncDefs: any) {
    this.subSyncDefs.databaseConfig = { mappings: [], source: { databaseName: '', sourceId: 1, sourceName: '', tableName: '' } };
    this.subSyncDefs.sqlqueryConfig = { limit: 10, pageNo: 1, pageSize: 10, source: { id: 0, name: '' }, sqlquery: ``, variables: [] };
    this.subSyncDefs.inputdataConfig = [];
    if (subSyncDefs.syncMode === 0) {
      this.subSyncDefs.databaseConfig = JSON.parse(subSyncDefs.syncConfig);
    }
    if (subSyncDefs.syncMode === 1) {
      this.subSyncDefs.sqlqueryConfig = JSON.parse(subSyncDefs.syncConfig);
    }
    if (subSyncDefs.syncMode === 2) {
      this.subSyncDefs.inputdataConfig = JSON.parse(subSyncDefs.syncConfig || '[]');
    }
  }

  async next() {
    if (this.current === 0) {
      const must: { field: 'subCode' | 'subName' | 'subPartition'; msessage: string }[] = [
        { field: 'subCode', msessage: '主题表编码不能为空' },
        { field: 'subName', msessage: '主题表名称不能为空' },
        { field: 'subPartition', msessage: '主题表分区不能为空' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
      if (!checkCode(this.formData.subCode)) {
        this.$message.error('编码只能包含英文字母、数字、下划线');
        return false;
      }
      if (!this.id) {
        let code = 'SUB_' + this.formData.subCode;
        let exist = await this.subjectSrv.getList({ subCode_eq: code });
        if (exist.length > 0) {
          this.$message.error(`编码[${code}]已经存在`);
          return false;
        }
      }
    }
    if (this.current === 1) {
      let result = this.checkSubFieldList();
      if (!result) {
        this.$message.error('请将主题表属性填写完整');
        return false;
      }
      let isChange = this.checkFieldsChange();
      if (isChange) {
        this.$confirm({
          title: '提示信息',
          content: '字段编码或字段类型变更，会自动废弃已同步数据。是否继续？',
          onOk: () => {
            this.current++;
          },
          onCancel() {}
        });
        return false;
      }
    }
    if (this.current === 5) {
      if (this.formData.subSyncDefs.jobMode === 1) {
        if (!this.formData.subSyncDefs.jobConfig.runDateFormat || !this.formData.subSyncDefs.jobConfig.runDateStr) {
          this.$message.error('请将执行时间信息填写完整');
        }
      }
      if (this.formData.subSyncDefs.jobMode === 2) {
        if (!this.formData.subSyncDefs.jobConfig.runDateStr) {
          this.$message.error('请将执行时间信息填写完整');
        }
      }
    }
    this.current++;
  }

  /**
   * 判断表字段变更状态
   * 0: 没有变化, 1: 更新, 2:增加,删除
   * 既有增加删除，又有更新记录。优先记录更新
   * 前端只校验是否有更新给提示信息，增加和删除状态提供给后端
   */
  checkFieldsChange() {
    if (this.oldFieldList.length > 0) {
      let isFieldsChange = 0;
      let isRemoved: boolean = false;
      this.oldFieldList.forEach(v => {
        let item = this.subFieldList.find(s => s.id === v.id);
        if (!item) {
          isRemoved = true;
        } else {
          if (item.fieldCode !== v.fieldCode || item.fieldType !== v.fieldType) isFieldsChange = 1;
        }
      });
      if (isFieldsChange !== 1 && isRemoved) isFieldsChange = 2;
      if (isFieldsChange === 0) isFieldsChange = this.oldFieldList.length === this.subFieldList.length ? 0 : 2;
      this.formData.isFieldsChange = isFieldsChange;
      return isFieldsChange === 1;
    }
    return false;
  }

  checkSubFieldList() {
    let result = true;
    this.subFieldList.forEach((v: any) => {
      if (!v.fieldCode || !v.fieldName || !v.fieldType || !v.fieldCategory) result = false;
    });
    return result;
  }

  loading: boolean = false;
  async confirm() {
    this.loading = true;
    let subFieldList = this.subFieldList.map((v: any, index: number) => ({ ...v, fieldSort: index + 1 }));
    if (this.id) {
      let res = await this.subjectSrv.update({ ...this.formData, subFieldList, subSyncDefs: this.subSyncDefs });
      if (res) {
        this.replaceUrlWithOutConfirm('/decision/subject/detail?id=' + this.id);
        this.initFormData();
      }
    } else {
      let categoryId: number | boolean = typeof this.$route.query.categoryId === 'string' ? parseInt(this.$route.query.categoryId) : false;
      if (!categoryId) {
        this.$message.error('参数错误：没有指定目录');
        return false;
      }
      this.formData.subCategoryId = categoryId;
      let res = await this.subjectSrv.add({ ...this.formData, subFieldList, subSyncDefs: this.subSyncDefs });
      if (res) {
        this.replaceUrlWithOutConfirm('/decision/subject/detail?id=' + res.id);
        this.initFormData();
      }
    }
    this.loading = false;
    this.HANDLE_RELOAD_SUB_MENU();
  }
  @Mutation HANDLE_RELOAD_SUB_MENU: any;
}
